import db from '@mobile/db/db';
import InspectionService from '@mobile/services/inspection';
import * as Sentry from '@sentry/browser';
import { eventBus } from '@/eventBus';

const storeName = 'inspections';

export default {

    async count() {
        await db.open();
        return await db.count(storeName);
    },

    async getAll() {
        await db.open();
        return await db.getAll(storeName);
    },

    async getQueueForUser(userId) {
        await db.open();

        const result = [];

        let cursor = await db
            .transaction(storeName)
            .store
            .index('user_id')
            .openCursor(IDBKeyRange.only(userId));

        while (cursor) {
            result.push(cursor.value);
            cursor = await cursor.continue();
        }

        return result;
    },

    async getQueueKeysForUser(userId) {
        await db.open();

        const result = [];

        let cursor = await db
            .transaction(storeName)
            .store
            .index('user_id')
            .openCursor(IDBKeyRange.only(userId));

        while (cursor) {
            result.push(cursor.value.id);
            cursor = await cursor.continue();
        }

        return result;
    },

    async put(inspection) {
        await db.open();
        return await db.put(storeName, inspection);
    },

    async send(id) {
        console.log('send', id);
        await db.open();
        const inspection = await db.get(storeName, id);
        console.log('send', id, inspection);

        let inspectionSentSuccessfully;

        try {
            eventBus.$emit('inspections-sending');
            inspectionSentSuccessfully = await InspectionService.send(inspection);
        } catch (err) {
            if (err.response) {
                eventBus.$emit('inspections-updated');
                if ([403, 404].includes(err.response.status)) { // when user has no permission anymore or inspection is no longer there
                    eventBus.$emit('uploadFailed', err.response.data.message);
                    await db.delete(storeName, id);
                } else { // this will only include axios errors that are not network errors
                    Sentry.captureException(err);
                }
            }
        }

        if (inspectionSentSuccessfully) {
            await db.delete(storeName, id);
        }

        return inspectionSentSuccessfully;
    },

    async sendQueueForUser(userId) {
        const inspectionIds = await this.getQueueKeysForUser(userId);
        console.log('send all', inspectionIds);

        for (const i in inspectionIds) {
            await this.send(inspectionIds[i]);
        }
    },
};
